import React, { memo } from 'react';
import { Badge } from 'reactstrap';
import PropTypes from 'prop-types';

const QuantityBadge = ({ count }) => {
  if (!count && count <= 0) return null;
  return (
    <Badge color="orange" pill>
      {count}
    </Badge>
  );
};
export default memo(QuantityBadge);

QuantityBadge.propTypes = {
  count: PropTypes.number,
};

QuantityBadge.defaultProps = {
  count: undefined,
};
